export function createFilteredUrlParams<T extends Record<string, any>>(params: T): string {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== undefined),
  ) as unknown as URLSearchParams;
  return new URLSearchParams(filteredParams).toString();
}
